export default "__VITE_ASSET__CPKk6uI9__"